import { render } from "./EarnerDetail.vue?vue&type=template&id=49ec56a0&lang=pug"
import script from "./EarnerDetail.vue?vue&type=script&lang=js"
export * from "./EarnerDetail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__